import React from 'react';
import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { HeadingSixStyle } from '../../styles/typography/heading.styles';

interface SixProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

interface SixComponent extends React.FC<SixProps> {
    Style?: typeof HeadingSixStyle;
}
export const Six: SixComponent = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(HeadingSixStyle, rest, children, Component);

Six.Style = HeadingSixStyle;
